import { combineReducers } from "redux";
import addUserReducer from "./adduser/reducers";
import assetReducer from "./asset/reducer";
import employeeReducer from "./employee/reducer";
import inventoryReducer from "./inventory/reducer";
import notificationReducer from "./notification/reducer";
import authenticationReducer from "./signin/reducer";
import signUpReducer from "./signup/reducer";
import storeReducer from "./store/reducer";
import supplierReducer from "./supplier/reducer";
import licenseReducer from "./license/reducer";
import loginReducer from "./signin/reducer";
import physicalInventoryReducer from "./physicalInventory/reducer";
import nonSaleableReturnReducer from "./nonsaleablereturn/reducer";

const rootReducer = combineReducers({
  authenticationReducer,
  notificationReducer,
  signUpReducer,
  addUserReducer,
  user: loginReducer,
  employee: employeeReducer,
  assets: assetReducer,
  supplier: supplierReducer,
  captureGoodsResponse: inventoryReducer,
  store: storeReducer,
  license: licenseReducer,
  physicalInventory: physicalInventoryReducer,
  nonSaleableReturn : nonSaleableReturnReducer
});

export default rootReducer;
